import { useRef } from 'react'
import { shallowEqual, isObject } from '@aytm/lib/common/object'

import { ISessionUseFeaturesState } from '../types'
import { ISurveyFeatures } from '../../actions/types'

export const DEFAULT_FEATURES: ISurveyFeatures = {
  imageProtector: true,
  hideOberig: false,
  feedback: false,
  matrixStickyHeader: false
}

const useFeaturesState: ISessionUseFeaturesState = currentActionState => {
  const featuresRef = useRef<ISurveyFeatures>({ ...DEFAULT_FEATURES })

  if (currentActionState.currentActionRef.current !== currentActionState.lastActionRef.current) {
    const lastFeatures = currentActionState.lastActionRef.current?.features
    const currentFeatures = currentActionState.currentActionRef.current?.features
    if (isObject(currentFeatures) && lastFeatures !== currentFeatures && !shallowEqual(currentFeatures, lastFeatures)) {
      Object.assign(featuresRef.current, currentFeatures)
    }
  }

  return { featuresRef } as const
}

export default useFeaturesState
